<template>
  <div>
    <Loading v-if="loading" />

    <v-container v-else class="py-10 py-sm-12 py-md-14 py-lg-16 px-1 px-sm-3">
      <PagesTitle :mod="mod">Equipamentos</PagesTitle>

      <v-row justify="center" class="mx-n1 mx-sm-n3 mt-8">
        <v-col
          cols="6"
          md="4"
          v-for="({ img, title }, keyItems) in items"
          :key="keyItems"
          class="pa-1 pa-sm-3"
        >
          <div class="relative item" v-if="img">
            <img :src="files + img" :alt="title" class="d-block item-img" />

            <div class="d-flex align-center justify-center item-caption">
              <div
                class="
                  text-h6 text-md-h5
                  white--text
                  font-weight-medium
                  text-uppercase text-center
                  px-3 px-sm-5 px-md-10
                  item-title
                "
              >
                {{ title }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-equipments",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 18px;
  overflow: hidden;
  .item-img {
    aspect-ratio: 362 / 450;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-caption {
    background-color: rgba(0, 0, 0, 0.3);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    .item-title {
      @media screen and (max-width: 600px) {
        word-break: normal;
        font-size: 14px !important;
      }
      @media screen and (max-width: 360px) {
        font-size: 11px !important;
      }
    }
  }
}
</style>
